/**
 * The impacted-version list for one vulnerability, under any sort or filters.
 * Case-folded, because a vulnerability id resolves case-insensitively while tag
 * ids match exactly, so a lowercase URL would otherwise miss its invalidation.
 */
export const impactedAppVersionsTag = (vulnerabilityId: string) => ({
  type: 'ImpactedAppVersions' as const,
  id: vulnerabilityId.toLowerCase(),
});
